import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/newhome/newsletter/leon-newsletter.webp")